import { j as s, c as p } from "./utils-BdNIfrGQ.js";
import { n as o } from "./normalize-spacing-DY0KSpr_.js";
const n = ({ spacing: r, children: a, ...e }) => /* @__PURE__ */ s.jsx("pre", { className: p(o(r), "whitespace-pre-wrap break-all"), ...e, children: a });
export {
  n as P
};
